import mitt, { Emitter, EventType, Handler } from "mitt";

/**
 * Extends the standard Emitter interface with a 'once' method
 * for single-execution event subscriptions
 */
interface CustomEmitter extends Emitter<Record<EventType, unknown>> {
	/**
	 * Registers a handler that will be executed exactly once for the specified event
	 * @template T Type of the event data
	 * @param type Event type to listen for
	 * @param handler Function to execute when event occurs
	 */
	once: <T = any>(type: EventType, handler: Handler<T>) => void;
}

/**
 * Application-wide event bus for cross-component communication
 * Implements pub/sub pattern with mitt as the underlying event emitter
 */
const eventBus = mitt() as CustomEmitter;

/**
 * Implementation of the 'once' method that automatically unsubscribes
 * after the first event occurrence
 * @template T Type of the event data
 * @param type Event type to listen for
 * @param handler Function to execute when event occurs
 */
eventBus.once = function <T = any>(type: EventType, handler: Handler<T>): void {
	const wrappedHandler: Handler<T> = (event) => {
    //@ts-ignore
		eventBus.off(type, wrappedHandler);
		handler(event);
	};
  //@ts-ignore
	eventBus.on(type, wrappedHandler);
};

export default eventBus;
